import React, { Component } from 'react';
//  import withSizes from 'react-sizes';
import './FAQ.css'
import NOIMG from 'asset/img/no_image.jpg'
import { Button, Modal, Form, FormGroup, ControlLabel, FormControl, Row, Col, DropdownButton, MenuItem } from 'react-bootstrap';
import Fontawesome from 'react-fontawesome'
import { Creatable } from 'react-select'
import LivechatStore from 'stores/LivechatStore'
import { Checkbox } from 'react-icheck'
import CategoryItem from './CategoryItem'
import QuestionItem from './QuestionItem'
import ConfirmPopup from 'component/element/ConfirmPopup'
// import { DragDropContext } from 'react-dnd'
// import HTML5Backend from 'react-dnd-html5-backend'
import { Editor } from '@tinymce/tinymce-react';
var NotificationSystem = require('react-notification-system')
const update = require('immutability-helper');
class FAQManagementPage extends Component {
  constructor(props) {
    super(props)
    this.state = {showFaqDel:false,showCategoryDel:false,category_active:-1,category_list:[],faq_active:-1,question_list:[],showFaq:false,actionFaq:'add',showCategory:false,actionCategory:'add',category_doc:this.newEmptyCategoryDoc(),question_doc:this.newEmptyQuestionDoc(),tags_option:[{label:'Tag 1',value:'1'},{label:'Tag 2',value:'2'},{label:'Tag 3',value:'3'}],lg:'Language Settings',lgEventKey:null}
  }  

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
    this.loadCategoryList(this.state.lgEventKey)
  }

  loadCategoryList(lgEventKey) {
    LivechatStore.loadCategoryList(lgEventKey===null?'en':lgEventKey,(result)=>{
      let category_list = []
      category_list = result.data.map((item,index)=>{
        item.seq = (index+1).toString()
        return item
      })
      this.setState({category_list:category_list})
    })
  }

  loadQuestionList(cat_id) {
    LivechatStore.loadQuestionList(cat_id,(result)=>{
      let question_list = []
      question_list = result.data.map((item,index)=>{
        item.seq = (index+1).toString()
        return item
      })
      this.setState({question_list:question_list})
    })
  }

  newEmptyCategoryDoc() {
    return {added_by:'',added_date:'',cat_id:'',description:'',is_hidden:'0',lang:'en',name:'',seq:'',tags:[]}
  }

  newEmptyQuestionDoc() {
    return {added_by:'',added_date:'',cat_id:'',faq_id:'',detail_html:'',lang:'en',title:'',seq:'',is_hidden:'0'}
  }

  onCategoryDocChange(field,e) {
    let {category_doc} = this.state
    category_doc[field] = e.target.value
    this.setState({category_doc:category_doc})
  }

  onQuestionDocChange(field,e) {
    let {question_doc} = this.state
    question_doc[field] = e.target.value
    this.setState({question_doc:question_doc})
  }

  onLanguageSelect(key) {
    if (key==='en')
      this.setState({lgEventKey:key,lg:'ENG'})
    else
      this.setState({lgEventKey:key,lg:'ไทย'})  
    this.loadCategoryList(key)  
  }

  onTagsChange(e) {
    let {category_doc,tags_option} = this.state
    if (e.length===0) {
      category_doc.tags = []
    } else {
      let tags = []
      e.forEach((item,index)=>{
        tags.push(item.value)
        let find = tags_option.findIndex(x=>x.value===item.value)
        if (find===-1) {
          tags_option.push({label:item.label,value:item.value})
        }
      })
      category_doc.tags = tags
    }
    this.setState({category_doc:category_doc,tags_option:tags_option})
  }

  onCategoryAddClick() {
    this.setState({showCategory:true,actionCategory:'add'})
  }

  onCategoryEditClick(item) {
    let {category_doc} = this.state
    category_doc = Object.assign(category_doc, item)
    this.setState({showCategory:true,actionCategory:'edit',category_doc:category_doc})
  }

  onCategorySaveClick() {
    let {category_doc,lgEventKey} = this.state
    let postData = category_doc
    LivechatStore.saveCategory(postData,(result)=>{
      if (result.status==='OK') {
        category_doc = this.newEmptyCategoryDoc()
        this.setState({category_doc:category_doc,showCategory:false,actionCategory:'add'})
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการบันทึกรายการสำเร็จ',
          level: 'info',
          position:'tc'
        });
        this.loadCategoryList(lgEventKey)
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'ทำการบันทึกรายการล้มเหลว',
        level: 'error',
        position:'tc'
      });
      this.setState({showCategory:false,category_doc:this.newEmptyCategoryDoc(),actionCategory:'add'})
    })
  }

  onQuestionSaveClick() {
    let {question_doc,category_active} = this.state
    if (category_active===-1) {
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'กรุณาเลือก Category ก่อนบันทึก',
        level: 'error',
        position:'tc'
      });
      this.setState({showFaq:false,faq_active:-1,question_doc:this.newEmptyQuestionDoc(),actionFaq:'add'})
      return false
    }
    let postData = question_doc
    postData.cat_id = category_active
    LivechatStore.saveQuestion(postData,(result)=>{
      if (result.status==='OK') {
        this.setState({question_doc:this.newEmptyQuestionDoc(),showFaq:false,faq_active:-1,actionFaq:'add'})
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการบันทึกรายการสำเร็จ',
          level: 'info',
          position:'tc'
        });
        this.loadQuestionList(category_active)
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'ทำการบันทึกรายการล้มเหลว',
        level: 'error',
        position:'tc'
      });
      this.setState({showFaq:false,faq_active:-1,question_doc:this.newEmptyQuestionDoc(),actionFaq:'add'})
    })
  }

  onHideCategoryChange() {
    let {category_doc} = this.state
    if (category_doc.is_hidden==='0')
      category_doc.is_hidden = '1'
    else
      category_doc.is_hidden = '0'
    this.setState({category_doc:category_doc})    
  }

  onHideQuestionChange() {
    let {question_doc} = this.state
    if (question_doc.is_hidden==='0')
      question_doc.is_hidden = '1'
    else
      question_doc.is_hidden = '0'
    this.setState({question_doc:question_doc})    
  }

  onCategorySelect(item) {
    this.setState({category_active:item.cat_id})
    this.loadQuestionList(item.cat_id)
  }

  onSortCategory() {
    let {category_list} = this.state
    let sort_category_list = category_list.map((item,index)=>{
      item.seq = (index+1).toString()
      return {cat_id:item.cat_id,seq:item.seq}
    })
    let postData = {data:sort_category_list}
    LivechatStore.saveCategorySort(postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการบันทึกรายการสำเร็จ',
          level: 'info',
          position:'tc'
        });
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'ทำการบันทึกรายการล้มเหลว',
        level: 'error',
        position:'tc'
      });
    })
  }

  onSortQuestion() {
    let {question_list} = this.state
    let sort_question_list = question_list.map((item,index)=>{
      item.seq = (index+1).toString()
      return {faq_id:item.faq_id,seq:item.seq}
    })
    let postData = {data:sort_question_list}
    LivechatStore.saveQuestionSort(postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการบันทึกรายการสำเร็จ',
          level: 'info',
          position:'tc'
        });
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'ทำการบันทึกรายการล้มเหลว',
        level: 'error',
        position:'tc'
      });
    })
  }

  onQuestionEditClick(item) {
    let {question_doc} = this.state
    LivechatStore.loadQuestionDoc(item.faq_id,(result)=>{
      question_doc = Object.assign(question_doc, result.data)
      this.setState({showFaq:true,actionFaq:'edit',question_doc:question_doc,faq_active:item.faq_id})
    })  
  }

  moveCategoryItem = (dragIndex, hoverIndex) => {
    const { category_list } = this.state
    const dragCard = category_list[dragIndex]

    this.setState(
      update(this.state, {
        category_list: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]],
        },
      }),
    )
  }

  moveQuestionItem = (dragIndex, hoverIndex) => {
    const { question_list } = this.state
    const dragCard = question_list[dragIndex]

    this.setState(
      update(this.state, {
        question_list: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]],
        },
      }),
    )
  }

  onEditorChange = (e)=>{
    let {question_doc} = this.state
    question_doc['detail_html'] = e.target.getContent()
    this.setState({question_doc:question_doc})
  }

  onFaqDelConfirm() {
    let {faq_active,category_active} = this.state
    LivechatStore.delQuestion(faq_active,(result)=>{
      if (result.status==='OK') {
        this.setState({showFaqDel:false,faq_active:-1,showFaq:false}) 
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำรายการลบ FAQ สำเร็จ',
          level: 'info',
          position:'tc'
        });
        this.loadQuestionList(category_active)
      }
    },()=>{
      this.setState({showFaqDel:false,faq_active:-1,showFaq:false})
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำรายการลบ FAQ ไม่สำเร็จ !',
        level: 'error',
        position:'tc'
      });
    }) 
  }

  onCategoryDelConfirm() {
    let {category_active,lgEventKey} = this.state
    LivechatStore.delCategory(category_active,(result)=>{
      if (result.status==='OK') {
        this.setState({showCategoryDel:false,category_active:-1,showCategory:false}) 
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำรายการลบ Category สำเร็จ',
          level: 'info',
          position:'tc'
        });
        this.loadCategoryList(lgEventKey)
      }
    },()=>{
      this.setState({showCategoryDel:false,category_active:-1,showCategory:false})
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำรายการลบ Category ไม่สำเร็จ !',
        level: 'error',
        position:'tc'
      });
    })
  }

  renderLanguageSelect() {
    let {lg} = this.state
    return(
      <DropdownButton id='language-select' bsStyle='link' title={lg} onSelect={this.onLanguageSelect.bind(this)}>
        <MenuItem eventKey={'en'}>EN</MenuItem>
        <MenuItem eventKey={'th'}>TH</MenuItem>
      </DropdownButton>
    )
  }

  renderHeader() {
    return(
      <div className='app-header'>
        <a className="navbar-brand" href="#">
          To add more languages: {this.renderLanguageSelect()}
        </a>
        <button style={{display:'none'}} className="navbar-toggler sidebar-toggler d-md-down-none" type="button" data-toggle="sidebar-lg-show">
          <Fontawesome name='bars' />
        </button>
      </div>
    )
  }

  renderSideBar() {
    let {category_list,category_active} = this.state
    return(
      <div className="sidebar py-3">
        <nav className="sidebar-nav ps">
          <ul className="nav">
            <li className="nav-item">
              <a className="nav-link" href="#">
                CATEGORIES
                <span className='add-category'>
                  <Button onClick={this.onCategoryAddClick.bind(this)}><Fontawesome className='text-green' name='plus-circle' /> Add Category</Button>
                </span>
              </a>
            </li>
            <li className={'nav-item'} style={{borderBottom:'none'}}>
              <a className="category-list nav-link" href="#" style={{backgroundColor:'#f7fcfd'}}>
              {category_list.map((item,index)=>
                <CategoryItem
                  key={index} 
                  item={item} 
                  id={item.cat_id}
                  index={index}
                  category_active={category_active}
                  moveCard={this.moveCategoryItem}
                  onCategorySelect={this.onCategorySelect.bind(this)}
                  onCategoryEditClick={this.onCategoryEditClick.bind(this)}
                  onSortSave={this.onSortCategory.bind(this)}
                />
              )}
              </a>
            </li>  
          </ul>
        </nav>    
      </div>
    )
  }

  renderTool() {
    let {category_list,category_active} = this.state
    let category_name = ''
    let find = category_list.findIndex(x=>x.cat_id===category_active)
    if (find!==-1)
      category_name = category_list[find].name
    return(
      <Row>
        <Col md={10}>
          <h3 className='mg-0'>{category_name}</h3>
        </Col>
        <Col md={2} className='text-right'>
          <Button bsStyle='primary' onClick={()=>{this.setState({showFaq:true,actionFaq:'add'})}}><Fontawesome name='plus-circle' /> Add FAQ</Button> 
        </Col>
      </Row>
    )
  }

  renderContent() {
    let {question_list} = this.state
    return(
      <div>
        {question_list.length>0?
        <div>
          <div className='faqs-count'>
            <small>FAQS ( {question_list.length} )</small>
          </div>
          <div>
            {question_list.map((item,index)=>
            <QuestionItem
              key={index} 
              item={item} 
              id={item.faq_id}
              index={index}
              moveCard={this.moveQuestionItem}
              onSortSave={this.onSortQuestion.bind(this)}
              onQuestionEditClick={this.onQuestionEditClick.bind(this)}
            />
            )}
          </div>
        </div> 
        :
        <div>
          <div className='faqs-count'>
            <small>FAQS ( 0 )</small>
          </div>
        </div>
      } 
      </div>
    ) 
  }

  renderMain() {
    let {category_active} = this.state
    if (category_active===-1) {
      return(<div className="main h-100 py-3"></div>)
    } else {
      return(
        <div className="main h-100 py-3">
          {this.renderTool()}
          <hr className='faq' />
          {this.renderContent()}
        </div>
      )
    }  
  }

  renderCategoryModal() {
    let {showCategory,category_doc,tags_option,actionCategory} = this.state
    return(
      <Modal show={showCategory} onHide={()=>{this.setState({showCategory:false,category_doc:this.newEmptyCategoryDoc(),actionCategory:'add'})}}>
        <Modal.Header closeButton>
          <Modal.Title>{actionCategory==='edit'?'EDIT':'ADD'} CATEGORY</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={8}>
              <Form>
                <FormGroup>
                  <ControlLabel>Title</ControlLabel>
                  <FormControl value={category_doc.name} onChange={this.onCategoryDocChange.bind(this,'name')} />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Description</ControlLabel>
                  <FormControl value={category_doc.description} onChange={this.onCategoryDocChange.bind(this,'description')} />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Tags</ControlLabel>
                  <Creatable
                    multi
                    onChange={this.onTagsChange.bind(this)}
                    options={tags_option}
                    placeholder='--- เลือกรายการ ---'
                    removeSelected={true}
                    value={category_doc.tags}
                  />
                  <i><small style={{fontSize:'10px'}}>Tags help you filter relevant categories to show to your app users</small></i>
                </FormGroup>
                <FormGroup>
                  <Checkbox
										onChange={this.onHideCategoryChange.bind(this)}
										checked={category_doc.is_hidden==='0'?false:true}
										checkboxClass="icheckbox_square-blue"
										increaseArea="20%"
										label={' ซ่อน Category'}
									>
									</Checkbox>
                </FormGroup>  
              </Form>
            </Col>
            <Col md={4}>
              <div className='text-center img-box'>
                <img alt='' src={NOIMG} />
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {actionCategory==='edit'?
          <Button bsStyle='danger' onClick={()=>{this.setState({showCategoryDel:true})}}><Fontawesome name='trash' />&nbsp;ลบข้อมูล</Button>
          :''}
          <Button bsStyle='primary' onClick={this.onCategorySaveClick.bind(this)}><Fontawesome name='save' />&nbsp;บันทึก</Button>
          <Button onClick={()=>{this.setState({showCategory:false,category_doc:this.newEmptyCategoryDoc(),actionCategory:'add'})}}><Fontawesome name='close' />&nbsp;ปิด</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderEditor(){
    let {question_doc} = this.state
    return (
      <Editor apiKey='6gwkhslly39m853sdjp0srhy1ryge1fvn3qqadzaufejkpx1' 
            initialValue={question_doc.detail_html}
            init={{
              height: 500,
              resize: true,
              plugins: 'link image code media mediaembed',
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | image code',
              //images_upload_url: LivechatStore.getImageUploadUrl(),
              //images_upload_credentials: true,
              images_upload_handler:  (blobInfo, success, failure)=> {
                console.log('upload success',blobInfo);
                LivechatStore.uploadImage(blobInfo,success,failure)
                setTimeout(function () {
                  /* no matter what you upload, we will turn it into TinyMCE logo :)*/
                  //success('http://moxiecode.cachefly.net/tinymce/v9/images/logo.png');
                }, 2000);
              }
            }}
            onChange={this.onEditorChange}
          />
    )
  }

  renderFaqPanel() {
    let {showFaq,question_doc,actionFaq,faq_active} = this.state
    return showFaq && (      
      <div className='panel panel-info'>
        <div className='panel-heading'>
          <h3 className='panel-title'>{actionFaq==='add'?'ADD':'EDIT'} FAQ</h3>
        </div>
        <div className='panel-body'>
          <Row>
            <Col md={12}>
              <Form>
                <FormGroup>
                  <ControlLabel>Title</ControlLabel>
                  <FormControl value={question_doc.title} onChange={this.onQuestionDocChange.bind(this,'title')} />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>FAQ</ControlLabel>
                  {this.renderEditor()}
                </FormGroup>
                <FormGroup>
                  <Checkbox
										onChange={this.onHideQuestionChange.bind(this)}
										checked={question_doc.is_hidden==='0'?false:true}
										checkboxClass="icheckbox_square-blue"
										increaseArea="20%"
										label={' ซ่อน FAQ'}
									>
									</Checkbox>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </div>
        <div className='panel-footer text-right'>
          {faq_active!==-1?
          <span>
            <Button bsStyle='danger' onClick={()=>{this.setState({showFaqDel:true})}}><Fontawesome name='trash' />&nbsp;ลบข้อมูล</Button>
            &nbsp;
          </span>  
          :''}
          <Button bsStyle='primary' onClick={this.onQuestionSaveClick.bind(this)}><Fontawesome name='save' />&nbsp;บันทึก</Button>&nbsp;
          <Button onClick={()=>{this.setState({showFaq:false,faq_active:-1,question_doc:this.newEmptyQuestionDoc(),actionFaq:'add'})}}><Fontawesome name='close' />&nbsp;ปิด</Button>
        </div>
      </div>
    )
  }

  renderFaqModal() {
    let {showFaq,question_doc,actionFaq,faq_active} = this.state
    return(
      <Modal dialogClassName={'fullwidth-dialog'} show={showFaq} onHide={()=>{this.setState({showFaq:false,faq_active:-1,question_doc:this.newEmptyQuestionDoc(),actionFaq:'add'})}}>
        <Modal.Header closeButton>
          <Modal.Title>{actionFaq==='add'?'ADD':'EDIT'} FAQ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <Form>
                <FormGroup>
                  <ControlLabel>Title</ControlLabel>
                  <FormControl value={question_doc.title} onChange={this.onQuestionDocChange.bind(this,'title')} />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>FAQ</ControlLabel>
                  {this.renderEditor()}
                </FormGroup>
                <FormGroup>
                  <Checkbox
										onChange={this.onHideQuestionChange.bind(this)}
										checked={question_doc.is_hidden==='0'?false:true}
										checkboxClass="icheckbox_square-blue"
										increaseArea="20%"
										label={' ซ่อน FAQ'}
									>
									</Checkbox>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {faq_active!==-1?
          <Button bsStyle='danger' onClick={()=>{this.setState({showFaqDel:true})}}><Fontawesome name='trash' />&nbsp;ลบข้อมูล</Button>
          :''}
          <Button bsStyle='primary' onClick={this.onQuestionSaveClick.bind(this)}><Fontawesome name='save' />&nbsp;บันทึก</Button>
          <Button onClick={()=>{this.setState({showFaq:false,faq_active:-1,question_doc:this.newEmptyQuestionDoc(),actionFaq:'add'})}}><Fontawesome name='close' />&nbsp;ปิด</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderAppBody(){
    const {showFaq} = this.state
    return (      
        <div className='app-body' style={{display:(showFaq?'none':'')}} >   
          {this.renderSideBar()}
          {this.renderMain()}
          {this.renderCategoryModal()}
        </div>              
    )
  }

  render() {
    let {showFaqDel,showCategoryDel} = this.state
    return(
      <div className='app app-faq-management'>
        {this.renderHeader()}
        {this.renderAppBody()}
        <div>
          {this.renderFaqPanel()}
        </div>
        <ConfirmPopup
          show={showFaqDel}
          message='ต้องการลบ FAQ รายการนี้หรือไม่ ?'
          onHide={()=>this.setState({showFaqDel:false})}
          onConfirm={this.onFaqDelConfirm.bind(this)}
        />
        <ConfirmPopup
          show={showCategoryDel}
          message='ต้องการลบ Category นี้หรือไม่ ?'
          onHide={()=>this.setState({showCategoryDel:false})}
          onConfirm={this.onCategoryDelConfirm.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )
  }
}

FAQManagementPage.defaultProps = {  
  
}


export default FAQManagementPage;
// export default DragDropContext(HTML5Backend)(FAQManagementPage);


// WEBPACK FOOTER //
// ./src/view/faq/FAQManagementPage.js